import TransactionDate from "./Dates/TransactionDate";
import Deadline from "./Dates/Deadline";
import AccountDate from "./Dates/AccountDate";
import React, {Fragment} from "react";
import {postData} from "../../../../../utils/request";
import isEqual from "lodash-es/isEqual";
import ComponentConfig from "../../../../form/ComponentConfig";
import TextInput from "../../../../form/TextInput";
import TabContent from "../../../../layout/TabContent";
import Tabs from "../../../../layout/Tabs";
import ContentLoader from "../../../../layout/ContentLoader";
import TextArea from "../../../../form/TextArea";
import {get} from "../../../../../utils/dotutils";
import DateTimeInput from "../../../../form/DateTimeInput";

class Szamlazz extends React.Component {
    render() {
        const {props, state, parent} = this.props;
        const {hidden, labels, pool, operationitems} = props;
        return (
            <Fragment>
                <div className="row form-row">
                    <Deadline {...this.props} />
                    <TransactionDate {...this.props} />
                    <AccountDate {...this.props} />
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <TextArea
                            name="invoice.comment"
                            label="Megjegyzés a számlához"
                            {...props.getProps("invoice.comment")}
                            value={props.getValue("invoice.comment")}
                            saveChanges={props.setFieldValue}
                        />
                    </div>
                </div>
            </Fragment>
        );
    }
}

class Billingo extends React.Component {
    render() {
        const {props, state, parent} = this.props;
        const {hidden, labels, pool, operationitems} = props;
        return (
            <Fragment>
                <div className="row form-row">
                    <Deadline {...this.props} />
                    <TransactionDate {...this.props} />
                    <AccountDate {...this.props} />
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <TextArea
                            name="invoice.comment"
                            label="Megjegyzés a számlához"
                            {...props.getProps("invoice.comment")}
                            value={props.getValue("invoice.comment")}
                            saveChanges={props.setFieldValue}
                        />
                    </div>
                </div>
            </Fragment>
        );
    }
}

class ExternalInvoice extends React.Component {
    render() {
        const {props, state, parent} = this.props;
        const {hidden, labels, pool, operationitems} = props;
        return (
            <Fragment>
                <div className="row form-row">
                    <div className="col-md-4">
                        <TextInput
                            name="invoice.billnum"
                            label="Bejövő számla száma"
                            {...props.getProps("invoice.billnum")}
                            value={props.getValue("invoice.billnum")}
                            saveChanges={props.setFieldValue}
                        />
                    </div>
                    <div className="col-md-4">
                        <TextInput
                            name="invoice.amount"
                            type="number"
                            label="Összege"
                            {...props.getProps("invoice.amount")}
                            value={props.getValue("invoice.amount")}
                            saveChanges={props.setFieldValue}
                        />
                    </div>
                    <div className="col-md-4">
                        <TextInput
                            name="invoice.vat_amount"
                            type="number"
                            label="Áfa tartalma"
                            {...props.getProps("invoice.vat_amount")}
                            value={props.getValue("invoice.vat_amount")}
                            saveChanges={props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-3">
                        <DateTimeInput
                            name="invoice.issuedate"
                            label="Kiállítás dátuma"
                            {...props.getProps("invoice.issuedate")}
                            value={props.getValue("invoice.issuedate")}
                            saveChanges={props.setFieldValue}
                        />
                    </div>
                    <TransactionDate {...this.props} />
                    <Deadline {...this.props} />
                    <AccountDate {...this.props} />
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <TextArea
                            name="invoice.comment"
                            label="Megjegyzés a számlához"
                            {...props.getProps("invoice.comment")}
                            value={props.getValue("invoice.comment")}
                            saveChanges={props.setFieldValue}
                        />
                    </div>
                </div>
            </Fragment>
        );
    }
}

class Invoice extends React.Component {

    state = {
        provider: null
    }

    componentDidMount() {
        this.getSettings();
    }

    getPartner = (props) => {
        return props.values?.invoice?.acting || props.values?.[props.default || "seller"];
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        const props = this.props.props;
        const pProps = prevProps.props;
        if (this.getPartner(props)?.partner_id !== this.getPartner(pProps)?.partner_id) {
            this.getSettings();
        }
    }

    getSettings = () => {
        this.setState({provider: null}, () => {
            const {props, state, parent} = this.props;
            this.partnerSettings && this.partnerSettings.abort && this.partnerSettings.abort();
            this.partnerSettings = postData({
                action: 'invoice.getPartnerSettings',
                partner: this.getPartner(props)?.partner_id
            });
            this.partnerSettings.then((response) => {
                this.setState({provider: response.invoiceprovider || this.props.componentConfig.config.default_provider});
            });
        });
    }

    render() {
        const propsTop = this.props;
        const {props, state, parent} = propsTop;
        const {hidden, labels, pool, operationitems} = props;
        let ProviderType = ContentLoader;
        switch (this.state.provider) {
            case "Szamlazz": ProviderType = Szamlazz; break;
            case "Billingo": ProviderType = Billingo; break;
            case "ExternalInvoice": ProviderType = ExternalInvoice; break;
        }
        const from = (props.values || {}).seller || ((props.values || {}).invoice || {}).from;
        const to = (props.values || {}).customer || ((props.values || {}).invoice || {}).to;
        const partner_id = this.getPartner(props)?.partner_id;
        let type = "seller";
        if (partner_id === props.values?.seller?.partner_id) {
            type = "seller";
        } else if (partner_id === props.values?.customer?.partner_id) {
            type = "customer";
        }
        if ((hidden || []).indexOf("invoice") === -1) {
            if (this.props.changeActing === true) {
                const sellerTab = <TabContent tabLabel={(this.props.TabsByName && (from || {}).name ? from.name : "Eladó") + " számláz"} tabName={"seller"}>
                    <ProviderType {...propsTop}/>
                </TabContent>;
                const customerTab = <TabContent tabLabel={(this.props.TabsByName && (to || {}).name ? to.name : "Vevő") + " számláz"} tabName={"customer"}>
                    <ProviderType {...propsTop}/>
                </TabContent>;
                return (
                    <div className="section">
                        <div className="section-title">Számlázás</div>
                        <Tabs
                            className="radio-style"
                            theme="default"
                            defaultTab={type}
                            currentTab={type}
                            onTabChange={(type) => {
                                if (type === "seller") {
                                    props.setFieldValue("invoice.acting", ((props.values || {}).seller || {}));
                                } else {
                                    props.setFieldValue("invoice.acting", ((props.values || {}).customer || {}));
                                }
                            }}
                        >
                            {!this.props.swapTabs ? sellerTab : null}
                            {customerTab}
                            {this.props.swapTabs ? sellerTab : null}
                        </Tabs>
                    </div>
                );
            } else {
                return <div className="row form-row">
                    <div className="section">
                        <div className="section-title">Számlázás</div>
                        <div className="col-md-12">
                            <ProviderType {...propsTop}/>
                        </div>
                    </div>
                </div>;
            }
        }
        return null;
    }
}

export default (props) => <ComponentConfig componentName="invoice" {...props}><Invoice /></ComponentConfig>;